import { X as CloseIcon } from "phosphor-react"
import React, { createRef, useEffect, useState } from "react"
import ReactDOM from "react-dom"
import { useDispatch } from "react-redux"
import { addOverlay, removeOverlay } from "../Actions/Overlay.action"
import { useOutsideClick } from "../Hooks/useOutsideClick"


export default ({ id, duration = "0.2s", from = "right", className, open, onClosed, showCloseButton = true, children, header, footer, disableOverlayClick = false }) => {
    const [slideIn, setSlideIn] = useState(open)
    const ref = createRef()
    const dispatch = useDispatch()

    if(!id)
        throw new Error("A (side-menu wide) unique \"id\" must be passed to side menu component")

    const close = () => {
        // Just sets "slideIn" to false, which triggers the animation to close it
        setSlideIn(false)
    }

    useEffect(() => {
        if(!slideIn) {
            // If not slide in, slide out :^)
            const newTimeoutId = setTimeout(() => {
                onClosed && onClosed()
            }, duration.substr(0, duration.length-1) * 1000)

            dispatch(removeOverlay(id))

            return () => clearTimeout(newTimeoutId)
        }
    }, [slideIn])

    useEffect(() => {
        // Triggered every time "open" is changed, initially as well
        setSlideIn(open)

        if(open) {
            dispatch(addOverlay(id, close))
        }
    }, [open])
    
    return open 
        ? ReactDOM.createPortal(
            <div className={"side-menu" + (slideIn ? " side-menu--open" : "") + (" from-" + from) + (className ? " " + className : "")} ref={ref} style={{transitionDuration: duration}}>
                {header && <div className="side-menu__header">
                    {header}
                    {showCloseButton && <CloseIcon size="20" className="side-menu__close-button" onClick={close} />}
                </div>}
                <div className="side-menu__content">
                    {children}
                </div>
                {footer && <div className="side-menu__footer">
                    {footer}
                </div>}
            </div>, 
            document.body
        )
        : null
}